import React, { useState, useEffect, useRef } from "react";
import "./TakeAdmission.css"; // Import CSS file
import { API_BASE_URL } from "./config";
import { showAlert } from "./showAlert";
import OTPModal from "./OTPModal";
import { useLoading } from "./LoadingContext";
import PaymentSuccessScreen from "./PaymentSuccessScreen";
import { flushSync } from "react-dom";
import IncompleteAdmission from "./IncompleteAdmission";

import { FaEye, FaEyeSlash } from "react-icons/fa";

const TakeAdmission = ({ onClose }) => {
  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState("");
  // const [inputMobile, setinputMobile] = useState("");
  const [inputEmail, setinputEmail] = useState("");
  const [showInstallmentSchedule, setShowInstallmentSchedule] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [admissionSessionToken, setAdmissionSessionToken] = useState("");
  const [admissionEmailEditToken, setAdmissionEmailEditToken] = useState("");
  const [extraletters, setextraletters] = useState("");
  const [isSendingOtp, setIsSendingOtp] = useState(false);

  const [counsellingChecked, setCounsellingChecked] = useState(false);
  const [counsellingPaid, setCounsellingPaid] = useState(false);
  const [counsellingData, setCounsellingData] = useState(null);

  const [counsellingCalendarDays, setCounsellingCalendarDays] = useState([]);
  const [counsellingSlotsLoading, setCounsellingSlotsLoading] = useState(false);
  const [counsellingSelectedDate, setCounsellingSelectedDate] = useState("");
  const [counsellingSelectedSlot, setCounsellingSelectedSlot] = useState(null);


  const [counsellingGoal, setCounsellingGoal] = useState("");
  const [counsellingPaymentStarted, setCounsellingPaymentStarted] = useState(false);
  // eslint-disable-next-line
  const [fee, setFee] = useState(350);
  const [paymentConfig, setPaymentConfig] = useState(null);
  const [couponCode, setCouponCode] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponData, setCouponData] = useState(null);
  const [showCouponSuccessModal, setShowCouponSuccessModal] = useState(false);
  const [couponApplying, setCouponApplying] = useState(false);
  const [selectedInstallmentNumbers, setSelectedInstallmentNumbers] = useState([]);

  const gstPercent = Number(paymentConfig?.gst_percent || 18);

  const registrationFee = Number(paymentConfig?.registration_fee || 350);




  const installmentSchedule = (paymentConfig?.installment_schedule || [
    { installment_number: 1, amount: 10000 },
    { installment_number: 2, amount: 10000 },
    { installment_number: 3, amount: 10000 },
    { installment_number: 4, amount: 10000 },
    { installment_number: 5, amount: 10000 },
    { installment_number: 6, amount: 10000 },
    { installment_number: 7, amount: 4100 },
  ]).map((item) => ({
    installment_number: Number(item.installment_number),
    month_number: Number(item.installment_number),
    day_min: (Number(item.installment_number) - 1) * 30 + 1,
    day_max: Number(item.installment_number) * 30,
    amount_inr: Number(item.amount),
  }));





  const [PaymentOptionShow, setPaymentOptionShow] = useState(false);

  const [studentId, setStudentId] = useState(null);

  const { showLoading, hideLoading } = useLoading();
  // const [PayOutHeading, setPayOutHeading] = useState("");
  const admissionFormRef = useRef(null);
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));



  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobileNumber: "",
    email: "",
    dob: "",
    education: "",
    city: "",
    password: "",
    confirmPassword: "",
  });

  const [submitted, setSubmitted] = useState(false); // State to track submission
  const [errorMessage, setErrorMessage] = useState(""); // State to handle validation errors
  // eslint-disable-next-line
  const [MBerrorMessage, setMBErrorMessage] = useState("");
  const [showSuccessScreen, setShowSuccessScreen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const [PaymentOrderGenerated, setPaymentOrderGenerated] = useState(false);
  const [newAdmission, setNewAdmission] = useState(false);
  const [admissionUnderProcess, setAdmissionUnderProcess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const admissionProcessRef = useRef(null);
  const [showAdmissionCounselling, setShowAdmissionCounselling] = useState(false);


  useEffect(() => {
    const fetchPaymentConfig = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/payment-config`);
        const data = await response.json();

        if (response.ok && data.status === "success") {
          setPaymentConfig(data);
          setFee(Number(data.registration_fee || 350));
        }
      } catch (error) {
        console.error("Payment config loading error:", error);
      }
    };

    fetchPaymentConfig();
  }, []);




  const checkCounsellingStatusAfterOtp = async (emailToCheck) => {
    if (!emailToCheck) {
      alert("Email not found. Please try again.");
      return;
    }

    showLoading("🔍 Checking your counselling status...");

    try {
      const response = await fetch(`${API_BASE_URL}/counselling/check-status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: emailToCheck.trim().toLowerCase(),
        }),
      });

      const data = await response.json();

      console.log("Counselling status response:", data);
      console.log("Counselling paid:", data.counselling_paid);
      console.log(
        "Show admission counselling should become true:",
        !data.counselling_paid
      );

      if (!response.ok) {
        alert(data.detail || "Unable to check counselling status.");
        return;
      }

      setCounsellingChecked(true);
      setCounsellingPaid(Boolean(data.counselling_paid));
      setCounsellingData(data);

      if (data.counselling_paid) {
        setShowAdmissionCounselling(false);

        setFee(registrationFee);
        setPaymentOrderGenerated(false);
        setPaymentOptionShow(true);

        window.scrollTo({
          top: 450,
          behavior: "smooth",
        });
      } else {
        setShowAdmissionCounselling(true);

        setFee(registrationFee);
        setPaymentOrderGenerated(false);
        setPaymentOptionShow(false);

        setTimeout(() => {
          const counsellingBox = document.querySelector(".admission-counselling-container");
          if (counsellingBox) {
            counsellingBox.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }, 300);
      }
    } catch (error) {
      console.error("Counselling status check error:", error);
      alert("Something went wrong while checking counselling status.");
    } finally {
      await sleep(700);
      hideLoading();
    }
  };


  const fetchCounsellingSlotsForAdmission = async () => {
    try {
      setCounsellingSlotsLoading(true);

      const response = await fetch(
        `${API_BASE_URL}/counselling/available-slots?days=90`
      );

      const data = await response.json();

      if (!response.ok) {
        alert(data.detail || "Unable to load counselling slots.");
        return;
      }

      if (data.status === "success") {
        const calendar = data.calendar || [];
        setCounsellingCalendarDays(calendar);

        if (calendar.length > 0) {
          setCounsellingSelectedDate(calendar[0].dateKey);
        }
      }
    } catch (error) {
      console.error("Counselling slot loading error:", error);
      alert("Unable to load counselling slots.");
    } finally {
      setCounsellingSlotsLoading(false);
    }
  };


  const activeCounsellingDay = React.useMemo(() => {
    return (
      counsellingCalendarDays.find(
        (day) => day.dateKey === counsellingSelectedDate
      ) || counsellingCalendarDays[0]
    );
  }, [counsellingCalendarDays, counsellingSelectedDate]);

  const getGstAmount = (amount) => Math.round((amount * gstPercent) / 100);
  const getTotalWithGst = (amount) => amount + getGstAmount(amount);

  const installmentBaseTotal = installmentSchedule.reduce(
    (sum, item) => sum + item.amount_inr,
    0
  );

  const installmentGstTotal = installmentSchedule.reduce(
    (sum, item) => sum + getGstAmount(item.amount_inr),
    0
  );

  const installmentGrandTotal = installmentBaseTotal + installmentGstTotal;



  const installmentTotalFee = installmentSchedule.reduce(
    (sum, item) => sum + item.amount_inr,
    0
  );

  // const remainingAfterFirstInstallment =
  //   installmentTotalFee - INSTALLMENT_FIRST_PAYMENT;


  
  const couponDiscountAmount = Number(
    couponData?.student_discount_amount || 0
  );





  const discountedInstallmentTotalFee = couponApplied
    ? Math.max(installmentTotalFee - couponDiscountAmount, 0)
    : installmentTotalFee;

  const discountedInstallmentTotalGst = Math.round(
    (discountedInstallmentTotalFee * gstPercent) / 100
  );

  const discountedInstallmentGrandTotal =
    discountedInstallmentTotalFee + discountedInstallmentTotalGst;



  useEffect(() => {
    if (
      submitted &&
      !isSendingOtp &&
      !showOtpModal &&
      inputEmail &&
      !counsellingChecked &&
      !PaymentOptionShow &&
      !showSuccessScreen
    ) {
      checkCounsellingStatusAfterOtp(inputEmail);
    }

    // eslint-disable-next-line
  }, [
    submitted,
    isSendingOtp,
    showOtpModal,
    inputEmail,
    counsellingChecked,
    PaymentOptionShow,
    showSuccessScreen,
  ]);


  useEffect(() => {
    if (submitted && counsellingChecked && !counsellingPaid) {
      fetchCounsellingSlotsForAdmission();
    }
    // eslint-disable-next-line
  }, [submitted, counsellingChecked, counsellingPaid]);

  useEffect(() => {
    if (showSuccessScreen || window.__ALLOW_PAYMENT_SUCCESS_REDIRECT) {
      return;
    }

    const handleNavigation = (event) => {
      if (window.__ALLOW_PAYMENT_SUCCESS_REDIRECT) {
        return;
      }

      const confirmation = window.confirm(
        "⚠️ Are you sure you want to leave? Your payment process may be interrupted."
      );

      if (!confirmation) {
        event.preventDefault();
        window.history.pushState(null, "", window.location.href);
      }
    };

    const handleRefresh = (event) => {
      if (window.__ALLOW_PAYMENT_SUCCESS_REDIRECT) {
        return;
      }

      const confirmation = window.confirm(
        "⚠️ Are you sure you want to refresh? Your payment progress will be lost."
      );

      if (!confirmation) {
        event.preventDefault();
        event.returnValue = "";
      }
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handleNavigation);
    window.addEventListener("beforeunload", handleRefresh);

    return () => {
      window.removeEventListener("popstate", handleNavigation);
      window.removeEventListener("beforeunload", handleRefresh);
    };
  }, [showSuccessScreen]);
  const handleApplyCoupon = async () => {
    const cleanCouponCode = couponCode.trim().toUpperCase();

    if (!cleanCouponCode) {
      alert("Please enter coupon code.");
      return;
    }

    try {
      setCouponApplying(true);
      showLoading("Checking coupon...");

      const response = await fetch(`${API_BASE_URL}/admission/referral/validate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          referral_code: cleanCouponCode,
        }),
      });

      const data = await response.json();

      if (!response.ok || data.valid !== true) {
        setCouponApplied(false);
        setCouponData(null);
        alert(data.message || data.detail || "Invalid coupon code.");
        return;
      }

      if (
        Number(data.discount) !== 5000 ||
        Number(data.total_payable) !== 27500
      ) {
        alert("Referral pricing could not be verified.");
        return;
      }

      setCouponApplied(true);
      setCouponData({
        ...data,
        coupon_code: data.referral_code,
        student_discount_amount: data.discount,
      });
      setCouponCode(cleanCouponCode);
      setShowCouponSuccessModal(true);
    } catch (error) {
      console.error("Coupon apply error:", error);
      alert("Unable to apply coupon. Please try again.");
    } finally {
      await sleep(500);
      hideLoading();
      setCouponApplying(false);
    }
  };


  const prepareTrainingPayment = async (planType) => {
    if (!studentId) {
      alert("Student ID missing. Please verify email again.");
      return;
    }

    try {
      showLoading("Preparing your payment plan...");

      const response = await fetch(`${API_BASE_URL}/payment/build-snapshot`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          student_id: studentId,
          plan_type: planType,
          coupon_code:
            couponApplied && couponCode.trim()
              ? couponCode.trim().toUpperCase()
              : null,
        }),
      });

      const data = await response.json();

      if (!response.ok || data.status !== "success") {
        alert(data.detail || "Unable to prepare payment plan.");
        return;
      }

      const snapshot = data.payment_plan_snapshot;

      if (planType === "ONE_TIME") {
        setFee(Number(snapshot.final_one_time_payable || 0));
        setSelectedInstallmentNumbers([]);
        setPaymentOptionShow(false);

        await sleep(100);

        createOrderInitialOrder("One Time Payment", Number(snapshot.final_one_time_payable || 0));
        return;
      }

      if (planType === "INSTALLMENT") {
        const firstInstallment = snapshot.final_installment_schedule.find(
          (item) => Number(item.installment_number) === 1
        );

        const firstInstallmentAmount = Number(firstInstallment?.final_amount || 0);

        setFee(firstInstallmentAmount);
        setSelectedInstallmentNumbers([1]);
        setPaymentOptionShow(false);

        await sleep(100);

        createOrderInitialOrder("Installment Payment", firstInstallmentAmount);
        return;
      }
    } catch (error) {
      console.error("Prepare training payment error:", error);
      alert("Unable to prepare payment plan.");
    } finally {
      await sleep(700);
      hideLoading();
    }
  };

  useEffect(() => {
    return () => {
      // Clean up Razorpay classes when component unmounts
      document.body.classList.remove("razorpay-active");
    };
  }, []);

  const handleNewAdmission = () => {
    setNewAdmission(true);
    setAdmissionUnderProcess(false);
    setTimeout(() => {
      if (admissionFormRef.current) {
        const offset = 100; // pixels from the top
        const top =
          admissionFormRef.current.getBoundingClientRect().top +
          window.scrollY -
          offset;

        window.scrollTo({ top, behavior: "smooth" });
      }
    }, 200); // adjust delay if necessary
  };

  const handleAdmissionUnderProcess = () => {
    setNewAdmission(false);
    setAdmissionUnderProcess(true);
    setTimeout(() => {
      if (admissionProcessRef.current) {
        const offset = 100; // adjust space from top
        const top =
          admissionProcessRef.current.getBoundingClientRect().top +
          window.scrollY -
          offset;

        window.scrollTo({ top, behavior: "smooth" });
      }
    }, 200); // short delay to allow rendering
  };

  const generateRandomCode = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let result = "";
    for (let i = 0; i < 4; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return result;
  };

  const OtpSendingModal = ({ isOpen, email }) => {
    if (!isOpen) return null;

    return (
      <div className="otp-modal-overlay">
        <div className="R-otp-message-container">
          <h5 className="R-otp-message-heading">
            A **secure 4-digit OTP** has been sent to your registered email:
            <br />
            <br />
            <strong className="R-otp-email">{email}</strong>
            <br />
            Please check your inbox.
          </h5>
        </div>
      </div>
    );
  };

  const handlesentOTP = async (studentUniqueId, email) => {
    if (studentUniqueId) {
      try {
        setIsSendingOtp(true); // ✅ Show OTP Sending Modal
        console.log("send otp function start");

        const randomcode = generateRandomCode();
        setextraletters(randomcode);

        const url_otpsend = `${API_BASE_URL}/send_mailOTP/${studentUniqueId}?email=${encodeURIComponent(
          email
        )}&code=${randomcode}`;

        console.log(url_otpsend); // ✅ Check if email is correct in console

        const responsesendotp = await fetch(url_otpsend, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });

        const dataotp = await responsesendotp.json();
        console.log(dataotp);

        if (dataotp.status === "success") {
          console.log("mail send --success");
        }
      } catch (error) {
        console.log("An error occurred");
      } finally {
        setIsSendingOtp(false); // ✅ Hide OTP Sending Modal
        setShowOtpModal(true);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Allow only alphabets (no numbers or special characters)
    if (name === "firstName" || name === "lastName" || name === "city") {
      const onlyLetters = value.replace(/[^A-Za-z ]/g, ""); // Remove numbers & special characters
      setFormData({ ...formData, [name]: onlyLetters });
    } else if (name === "email") {
      setFormData({ ...formData, [name]: value.toLowerCase() });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const validateForm = () => {
    const {
      firstName,
      lastName,
      mobileNumber,
      email,
      dob,
      education,
      city,
      password,
      confirmPassword,
    } = formData;

    if (
      !firstName ||
      !lastName ||
      !mobileNumber ||
      !email ||
      !dob ||
      !education ||
      !city ||
      !password ||
      !confirmPassword
    ) {
      setErrorMessage("❌ Please fill all required fields.");
      return false;
    }
    if (mobileNumber.length !== 10 || !/^\d+$/.test(mobileNumber)) {
      setErrorMessage("❌ Mobile number must be exactly 10 digits.");
      return false;
    }

    if (firstName.trim().toLowerCase() === lastName.trim().toLowerCase()) {
      setErrorMessage("❌ First name and last name cannot be the same.");

      return false;
    }

    if (password.length < 6) {
      setErrorMessage("❌ Password must be at least 6 characters long.");
      return false;
    }

    if (password !== confirmPassword) {
      setErrorMessage("❌ Password and Confirm Password do not match.");
      return false;
    }

    if (!photo) {
      setErrorMessage("❌ Please upload a photo as per guidelines.");
      return false;
    }

    // setinputMobile(mobileNumber);

    setErrorMessage(""); // Clear error if form is valid
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form before making the request
    if (!validateForm()) {
      return;
    }

    showLoading(
      "🤖 AI is verifying inputs... Ensuring mobile number and email are unique."
    );

    try {
      // Prepare form data for submission
      const formDataToSend = new FormData();
      formDataToSend.append("first_name", formData.firstName);
      formDataToSend.append("last_name", formData.lastName);
      formDataToSend.append("mobile_number", formData.mobileNumber);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("dob", formData.dob);
      formDataToSend.append("education", formData.education);
      formDataToSend.append("password", formData.password);
      formDataToSend.append("confirm_password", formData.confirmPassword);

      let ip_address = "NA",
        latitude = "NA",
        longitude = "NA",
        city = "NA",
        region = "NA",
        country = "NA",
        isp = "NA";

      // Fetch user's IP-based location (without breaking form submission)
      const ipResponse = await fetch(
        "https://ipinfo.io/json?token=652654812dc5e9"
      ).catch(() => null);

      if (ipResponse && ipResponse.ok) {
        const ipData = await ipResponse.json().catch(() => ({})); // Fallback to empty object if JSON parsing fails

        // Extract data safely (fallback to "NA" if missing)
        ip_address = ipData.ip || "NA";
        latitude = ipData.loc ? parseFloat(ipData.loc.split(",")[0]) : "NA";
        longitude = ipData.loc ? parseFloat(ipData.loc.split(",")[1]) : "NA";
        city = ipData.city || "NA";
        region = ipData.region || "NA";
        country = ipData.country || "NA";
        isp = ipData.org || "NA";
      }

      // Append location data to formData
      formDataToSend.append("ip_address", ip_address);
      formDataToSend.append("latitude", latitude);
      formDataToSend.append("longitude", longitude);
      formDataToSend.append("city", city);
      formDataToSend.append("region", region);
      formDataToSend.append("country", country);
      formDataToSend.append("isp", isp);

      setinputEmail(formData.email);

      // Append photo if available
      if (photo) {
        formDataToSend.append("photo", photo);
      }

      const response = await fetch(`${API_BASE_URL}/signin`, {
        method: "POST",
        body: formDataToSend,
      });

      const data = await response.json();
      // Registration response intentionally not logged (contains a short-lived token).

      if (response.ok) {
        switch (data.detail) {
          case "Mobile number and Email already exist":
            showAlert(
              "❌ Both the mobile number and email are already registered. Please use different details."
            );
            setSubmitted(false);
            break;
          case "Mobile number already exists":
            showAlert(
              "❌ The mobile number is already registered. Please use a different number."
            );
            setSubmitted(false);
            break;
          case "Email already exists":
            showAlert(
              "❌ The email is already registered. Please use a different email."
            );
            setSubmitted(false);
            break;
          default:
            console.log("✅ Sign up successful!");
            setSubmitted(true); // Hide form, show success message

            if (data.student_unique_id) {
              setStudentId(data.student_unique_id);
              setAdmissionEmailEditToken(data.new_admission_email_edit_token || "");
              console.log("Student Unique ID:", data.student_unique_id);
              handlesentOTP(data.student_unique_id, formData.email);
            }

            window.scrollTo({
              top: 300,
              behavior: "smooth",
            });

            break;
        }
      } else {
        // Handle API errors
        switch (data.detail) {
          case "Mobile number and Email already exist":
            showAlert(
              "❌ Both the mobile number and email are already registered. Please use different details."
            );
            break;
          case "Mobile number already exists":
            showAlert(
              "❌ The mobile number is already registered. Please use a different number."
            );
            break;
          case "Email already exists":
            showAlert(
              "❌ The email is already registered. Please use a different email."
            );
            break;
          default:
            console.error(
              "Sign-up failed:",
              data.detail || response.statusText
            );
            showAlert(
              "⚠️ An error occurred: " + (data.detail || "Unknown error")
            );
            break;
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
      showAlert("⚠️ A network error occurred. Please try again.");
    } finally {
      await sleep(700);
      hideLoading();
    }
  };

  const handleFileChange = (e) => {
    setErrorMessage("");
    setPhotoPreview("");
    setMBErrorMessage("");
    setPhoto(null);
    const file = e.target.files[0];
    if (file) {
      // Validate file size (max 5MB)
      const maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        setPhotoPreview("");
        setPhoto(null);

        setMBErrorMessage(
          <span style={{ color: "red", fontWeight: "bold" }}>
            File size should be less than 5MB.
          </span>
        );

        showAlert(" File size should be less than 5MB.");
        return;
      }

      setErrorMessage(""); // Clear error if file size is valid
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhoto(file);
        setPhotoPreview(reader.result); // Set the photo preview
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAdmissionCounsellingPayment = async () => {
    if (!counsellingSelectedSlot) {
      alert("Please select counselling slot first.");
      return;
    }

    if (!formData.city.trim()) {
      alert("City is missing. Please go back and enter city in admission form.");
      return;
    }

    try {
      setCounsellingPaymentStarted(true);
      showLoading("Preparing your counselling payment...");

      const startResponse = await fetch(
        `${API_BASE_URL}/counselling/start-from-admission`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            full_name: `${formData.firstName} ${formData.lastName}`.trim(),
            student_type: formData.education,
            date_of_birth: formData.dob,
            mobile: formData.mobileNumber,
            email: formData.email.trim().toLowerCase(),
            city: formData.city.trim(),
            goal: counsellingGoal.trim(),
            counselling_date: counsellingSelectedDate,
            slot_time: counsellingSelectedSlot.time,
          }),
        }
      );

      const startData = await startResponse.json();

      if (!startResponse.ok) {
        alert(startData.detail || "Unable to start counselling booking.");
        await fetchCounsellingSlotsForAdmission();
        return;
      }

      if (startData.already_paid) {
        setCounsellingPaid(true);
        setCounsellingData(startData);
        setPaymentOptionShow(true);
        setCounsellingPaymentStarted(false);
        await sleep(700);
        hideLoading();
        return;
      }

      const bookingId = startData.booking_id;

      const orderResponse = await fetch(
        `${API_BASE_URL}/counselling/create-payment-order`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            booking_id: bookingId,
          }),
        }
      );

      const orderData = await orderResponse.json();

      if (!orderResponse.ok) {
        alert(orderData.detail || "Unable to create counselling payment order.");
        await fetchCounsellingSlotsForAdmission();
        return;
      }

      await sleep(700);
      hideLoading();

      const options = {
        key: orderData.key_id,
        amount: orderData.total_amount * 100,
        currency: "INR",
        name: "StudyAIPlacement Counselling",
        description: "Personal Career Counselling Fee",
        order_id: orderData.order_id,

        handler: async function (response) {
          try {
            showLoading(
              "Verifying counselling payment and confirming your slot..."
            );

            const verifyResponse = await fetch(
              `${API_BASE_URL}/counselling/verify-payment`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  booking_id: bookingId,
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_signature: response.razorpay_signature,
                }),
              }
            );

            const verifyData = await verifyResponse.json();

            if (!verifyResponse.ok) {
              alert(verifyData.detail || "Counselling payment verification failed.");
              await fetchCounsellingSlotsForAdmission();
              return;
            }

            setCounsellingPaid(true);
            setCounsellingData(verifyData);
            setShowAdmissionCounselling(false);
            setPaymentOptionShow(true);
            setCounsellingPaymentStarted(false);

            await fetchCounsellingSlotsForAdmission();

            await sleep(700);
            hideLoading();

            window.scrollTo({
              top: 450,
              behavior: "smooth",
            });
          } catch (error) {
            console.error("Counselling verify error:", error);
            alert("Counselling payment verification failed.");
            setCounsellingPaymentStarted(false);
            hideLoading();
          } finally {
            hideLoading();
            document.body.classList.remove("razorpay-active");
          }
        },

        modal: {
          escape: false,
          backdropclose: false,
          ondismiss: function () {
            setCounsellingPaymentStarted(false);
            document.body.classList.remove("razorpay-active");
            alert(
              "Counselling payment was not completed. Please complete it to continue admission."
            );
          },
        },

        theme: {
          color: "#3399cc",
        },
      };

      const rzp = new window.Razorpay(options);
      document.body.classList.add("razorpay-active");
      rzp.open();
    } catch (error) {
      console.error("Counselling payment error:", error);
      alert("Something went wrong while starting counselling payment.");
      setCounsellingPaymentStarted(false);
    } finally {
      await sleep(700);
      hideLoading();
    }
  };

  const createOrderInitialOrder = async (flag, FeeSelected) => {
    if (!studentId) {
      alert("Student ID missing. Please verify email again.");
      return;
    }

    if (!FeeSelected || FeeSelected < 0) {
      alert("Invalid payment amount.");
      return;
    }

    setPaymentOrderGenerated(true);
    showLoading("🔄 Processing your transaction... Just a moment!");

    try {
      let requestBody = {
        student_id: studentId,
      };

      if (flag === "New Admission") {
        if (!admissionSessionToken) {
          alert("Please verify your email OTP again before payment.");
          setPaymentOrderGenerated(false);
          return;
        }

        requestBody.payment_context = "NEW_ADMISSION";
        requestBody.admission_session_token = admissionSessionToken;

        if (couponApplied && couponCode.trim()) {
          requestBody.coupon_code = couponCode.trim().toUpperCase();
        }
      } else if (flag === "enrollment_fee") {
        requestBody.payment_context = "REGISTRATION";
      } else if (flag === "One Time Payment") {
        requestBody.payment_context = "TRAINING_ONE_TIME";
        requestBody.plan_type = "ONE_TIME";

        if (couponApplied && couponCode.trim()) {
          requestBody.coupon_code = couponCode.trim().toUpperCase();
        }
      } else if (flag === "Installment Payment") {
        requestBody.payment_context = "TRAINING_INSTALLMENT";
        requestBody.plan_type = "INSTALLMENT";
        requestBody.installment_numbers =
          selectedInstallmentNumbers.length > 0 ? selectedInstallmentNumbers : [1];

        if (couponApplied && couponCode.trim()) {
          requestBody.coupon_code = couponCode.trim().toUpperCase();
        }
      } else {
        alert("Invalid payment type.");
        setPaymentOrderGenerated(false);
        return;
      }

      const response = await fetch(`${API_BASE_URL}/payment/create-order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (!response.ok || !data.order_id) {
        alert(data.detail || "Failed to create order.");
        setPaymentOrderGenerated(false);
        return;
      }

      await sleep(700);
      hideLoading();

      const options = {
        key: data.key_id,
        amount: Math.round(Number(data.total_amount) * 100),
        currency: data.currency || "INR",
        name: "StudyAIPlacement",
        description:
          flag === "New Admission"
            ? "Programme Admission Fee"
            : flag === "Installment Payment"
            ? "Technology Learning Fee - Installment"
            : flag === "One Time Payment"
              ? "Technology Learning Fee - One Time"
              : "Registration Fee",
        order_id: data.order_id,

        handler: async (response) => {
          try {
            showLoading("🧠 Verifying your payment...");

            const verifyResponse = await fetch(`${API_BASE_URL}/payment/verify`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                razorpay_order_id: String(response.razorpay_order_id),
                razorpay_payment_id: String(response.razorpay_payment_id),
                razorpay_signature: String(response.razorpay_signature),
              }),
            });

            const verifyData = await verifyResponse.json();

            if (!verifyResponse.ok) {
              alert(verifyData.detail || "Payment verification failed.");
              setPaymentOrderGenerated(false);
              return;
            }

            setPaymentOrderGenerated(false);

            if (flag === "New Admission" || flag === "One Time Payment" || flag === "Installment Payment") {
              window.__ALLOW_PAYMENT_SUCCESS_REDIRECT = true;

              flushSync(() => {
                setShowSuccessScreen(true);
                setPaymentOptionShow(false);

                setSuccessMessage(
                  <>
                    <p>🎉 Congratulations! Your payment has been verified successfully.</p>

                    <p>
                      {flag === "One Time Payment"
                        ? "Your full Technology Learning Fee has been paid."
                        : flag === "New Admission"
                        ? "Your programme admission fee is paid, including GST."
                        : "Your first installment has been paid successfully."}
                    </p>

                    <p>Welcome to StudyAIPlacement. Your learning journey is now activated.</p>

                    <p>You can now continue to the student portal.</p>
                  </>
                );
              });
            }

            if (flag === "enrollment_fee") {
              setPaymentOptionShow(true);

              window.scrollTo({
                top: 450,
                behavior: "smooth",
              });
            }
          } catch (error) {
            console.error("Payment verification error:", error);
            alert("Payment verification failed.");
            setPaymentOrderGenerated(false);
          } finally {
            await sleep(700);
            hideLoading();
            document.body.classList.remove("razorpay-active");
          }
        },

        theme: { color: "#3399cc" },
        display: "fullscreen",

        modal: {
          escape: false,
          backdropclose: false,
          ondismiss: function () {
            document.body.classList.remove("razorpay-active");
            setPaymentOrderGenerated(false);

            if (flag === "New Admission" || flag === "One Time Payment" || flag === "Installment Payment") {
              setPaymentOptionShow(true);
            }
          },
        },
      };

      const rzp = new window.Razorpay(options);
      document.body.classList.add("razorpay-active");
      rzp.open();
    } catch (error) {
      console.error("Error creating order:", error);
      alert("Failed to create order.");
      setPaymentOrderGenerated(false);
    } finally {
      await sleep(700);
      hideLoading();
      document.body.classList.remove("razorpay-active");
    }
  };



  const handleCloseAdmissionProcess = () => {
    setAdmissionUnderProcess(false);
    onClose();
  };

  const setShowIncompleteAdmission = () => {
    setAdmissionUnderProcess(false);
  };

  return (
    <div className="take-admission-container admission-page">
      <section className="admission-hero-section">
        <div className="admission-hero-bg"></div>

        {/* <div className="admission-close-row">
        <button className="admission-page-close" onClick={onClose}>
          Close
        </button>
      </div> */}

        <div className="admission-hero-content">
          <span className="admission-kicker">
            ADMISSION DESK
          </span>

          <h1>Start or Continue Your Admission</h1>

          <p>
            Choose the correct option below. New students can start the admission
            process, and already registered students can continue from their
            pending payment or admission step.
          </p>
        </div>

        <div className="admission-option-grid">
          <button
            type="button"
            className={`admission-option-card ${newAdmission ? "active" : ""}`}
            onClick={handleNewAdmission}
          >
            <div className="admission-option-top">
              <span>01</span>
              <b>New Student</b>
            </div>

            <h2>Start New Admission</h2>

            <p>
              Choose this if you are applying for the first time and have not
              filled the admission form before.
            </p>

            <div className="admission-flow-line">
              <span>Form</span>
              <i></i>
              <span>Email OTP</span>
              <i></i>
              <span>Referral (Optional)</span>
              <i></i>
              <span>Admission Payment</span>
            </div>

            <strong>Start Admission →</strong>
          </button>

          <button
            type="button"
            className={`admission-option-card ${admissionUnderProcess ? "active" : ""
              }`}
            onClick={handleAdmissionUnderProcess}
          >
            <div className="admission-option-top">
              <span>02</span>
              <b>Already Started</b>
            </div>

            <h2>Continue Admission</h2>

            <p>
              Already submitted your details? Securely verify your email,
              check your admission status and continue your pending steps.
            </p>

            <div className="admission-flow-line">
              <span>Email</span>
              <i></i>
              <span>OTP</span>
              <i></i>
              <span>Status Check</span>
              <i></i>
              <span>Continue</span>
            </div>

            <strong>Continue Process →</strong>
          </button>
        </div>

        <div className="admission-fee-note">
          <span>Admission Fee (incl. GST)</span>
          <b>₹32,500</b>
          <i></i>
          <span>With Valid Referral</span>
          <b>₹27,500</b>
          <i></i>
          <span>After Placement</span>
          <b>First Month's Salary*</b>
        </div>
      </section>

      {newAdmission && (
        <>
          {!submitted ? (
            <div className="take-admission-form admission-form-premium" ref={admissionFormRef}>
              <div className="admission-section-heading">
                <span>NEW ADMISSION</span>
                <h2>Fill Your Admission Details</h2>
                <p>
                  Enter your details carefully. Verify your email using OTP
                  before proceeding to the admission payment.
                </p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <div className="labeldiv">
                    <label>First Name</label>
                  </div>
                  <div className="inputdiv">
                    <input
                      type="text"
                      name="firstName"
                      placeholder="Enter first name"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                      maxLength={50}
                      className="input-enter"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <div className="labeldiv">
                    <label>Last Name</label>
                  </div>
                  <div className="inputdiv">
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                      placeholder="Enter last name"
                      maxLength={50}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <div className="labeldiv">
                    <label>Mobile Number</label>
                  </div>
                  <div className="inputdiv">
                    <input
                      type="text"
                      name="mobileNumber"
                      value={formData.mobileNumber}
                      onChange={handleChange}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                      }}
                      required
                      placeholder="Enter mobile number"
                      maxLength={10}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <div className="labeldiv">
                    <label>Email</label>
                  </div>
                  <div className="inputdiv">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="Enter email address"
                      maxLength={50}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <div className="labeldiv">
                    <label>Date of Birth</label>
                  </div>
                  <div className="inputdiv Pr-date-input">
                    <input
                      type="date"
                      name="dob"
                      value={formData.dob}
                      onChange={handleChange}
                      required
                      max={new Date().toISOString().split("T")[0]}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <div className="labeldiv">
                    <label>Education</label>
                  </div>
                  <div className="inputdiv">
                    <input
                      type="text"
                      name="education"
                      value={formData.education}
                      onChange={handleChange}
                      required
                      placeholder="Enter highest education"
                      maxLength={50}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <div className="labeldiv">
                    <label>City</label>
                  </div>

                  <div className="inputdiv">
                    <input
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      required
                      placeholder="Enter city"
                      maxLength={50}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <div className="labeldiv pswd-eye">
                    <label>Password</label>
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      className="eye-password"
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                  <div className="inputdiv">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                      placeholder="Create password"
                      maxLength={50}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <div className="labeldiv">
                    <label>Confirm Password</label>
                  </div>
                  <div className="inputdiv">
                    <input
                      type="password"
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      required
                      placeholder="Confirm password"
                      maxLength={50}
                    />
                  </div>
                </div>

                <div className="form-group full-row">
                  <div className="labeldiv">
                    <label>
                      Upload Photo
                      <span> File size should be less than 5MB.</span>
                    </label>
                  </div>
                  <div className="inputdiv">
                    <input
                      type="file"
                      name="photo"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>

                {photoPreview && (
                  <div className="photo-preview">
                    <img src={photoPreview} alt="Preview" />
                  </div>
                )}

                <div className="consent-wrapper">
                  <div className="consent-container">
                    <input type="checkbox" id="consent" required />
                    <label htmlFor="consent">
                      I confirm that I have read all the details provided across
                      the website and I fully agree to the terms, policies, and
                      procedures of <strong>StudyAIPlacement</strong>.
                    </label>
                  </div>
                </div>



                {errorMessage && (
                  <div className="error-message">
                    <p>{errorMessage}</p>
                  </div>
                )}

                <div className="submit-btn">
                  <button className="submit-btn" type="submit">
                    Verify Email & Continue
                  </button>
                </div>
              </form>
            </div>
          ) : (
            <div>
              {isSendingOtp && (
                <OtpSendingModal isOpen={isSendingOtp} email={inputEmail} />
              )}

              {/* {showOtpModal && (
                <OTPModal
                  student_id={studentId}
                  email={inputEmail}
                  extraletters={extraletters}
                  showEditMail={true}
                  onClose={() => setShowOtpModal(false)}
                />
              )} */}

              {showOtpModal && (
                <OTPModal
                  student_id={studentId}
                  email={inputEmail}
                  extraletters={extraletters}
                  showEditMail={true}
                  editToken={admissionEmailEditToken}
                  onEmailChanged={setinputEmail}
                  onClose={async (sessionToken) => {
                    if (!sessionToken) {
                      return;
                    }

                    setAdmissionSessionToken(sessionToken);
                    setShowOtpModal(false);
                    // New enrolments use the new admission fee; counselling is free.
                    setShowAdmissionCounselling(false);
                    setCounsellingChecked(false);
                    setCounsellingPaid(false);
                    setPaymentOrderGenerated(false);
                    setPaymentOptionShow(true);
                  }}
                />
              )}
            </div>
          )}
        </>
      )}

      {admissionUnderProcess && (
        <div ref={admissionProcessRef} className="continue-admission-premium">
          <IncompleteAdmission
            onClose={handleCloseAdmissionProcess}
            setShowIncompleteAdmission={setShowIncompleteAdmission}
          />
        </div>
      )}

      {counsellingChecked && counsellingPaid && counsellingData && PaymentOptionShow && (
        <div className="counselling-already-paid-box">
          <strong>✅ Counselling step completed</strong>
          <p>
            Your counselling slot is already confirmed for{" "}
            <b>{counsellingData.counselling_date}</b> at{" "}
            <b>{counsellingData.slot_time}</b>. You can now continue with your
            Technology Learning Fee.
          </p>
        </div>
      )}


      {showAdmissionCounselling &&
        !PaymentOptionShow &&
        !PaymentOrderGenerated &&
        !showSuccessScreen && (
          <>
            <div className="payment-overlay"></div>

            <div className="admission-counselling-container">
              <div className="admission-counselling-header">
                <span>FIRST STEP OF YOUR JOURNEY</span>

                <h2>Book Personal Career Counselling</h2>

                <p>
                  Before admission moves ahead, Akshay Sir personally understands the
                  student’s skills, goals, confusion, discipline, life ambition and
                  career direction.
                </p>
              </div>

              <div className="admission-counselling-grid">
                <div className="admission-counselling-card">
                  <div className="admission-counselling-card-title">
                    <span>01</span>

                    <div>
                      <h3>Select counselling slot</h3>
                      <p>Choose your preferred date and time.</p>
                    </div>
                  </div>

                  {counsellingSlotsLoading ? (
                    <div className="admission-slot-empty">
                      Loading counselling slots...
                    </div>
                  ) : (
                    <>
                      <div className="admission-date-scroll">
                        {counsellingCalendarDays.map((day) => (
                          <button
                            key={day.dateKey}
                            type="button"
                            className={
                              counsellingSelectedDate === day.dateKey
                                ? "admission-date-pill active"
                                : "admission-date-pill"
                            }
                            onClick={() => {
                              setCounsellingSelectedDate(day.dateKey);
                              setCounsellingSelectedSlot(null);
                            }}
                          >
                            <span>{day.dayName}</span>
                            <strong>{day.dateText}</strong>
                          </button>
                        ))}
                      </div>

                      <div className="admission-month-label">
                        {activeCounsellingDay?.monthText}
                      </div>

                      <div className="admission-slot-grid">
                        {activeCounsellingDay?.slots.map((slot) => (
                          <button
                            key={slot.id}
                            type="button"
                            disabled={slot.status === "booked"}
                            className={[
                              "admission-slot-card",
                              slot.status === "booked" ? "booked" : "available",
                              counsellingSelectedSlot?.id === slot.id ? "selected" : "",
                            ].join(" ")}
                            onClick={() => setCounsellingSelectedSlot(slot)}
                          >
                            <strong>{slot.time}</strong>

                            <span>
                              {slot.status === "booked"
                                ? "Already Booked"
                                : "Available"}
                            </span>
                          </button>
                        ))}
                      </div>
                    </>
                  )}
                </div>

                <div className="admission-counselling-card">
                  <div className="admission-counselling-card-title">
                    <span>02</span>

                    <div>
                      <h3>Confirm counselling step</h3>
                      <p>Only missing details are required here.</p>
                    </div>
                  </div>

                  <div className="admission-counselling-note">
                    <strong>Why this step matters</strong>

                    <p>
                      This is not a random counselling call. Akshay Sir studies the
                      student profile and gives the right learning roadmap before
                      proceeding with Technology Learning Fee.
                    </p>
                  </div>



                  <label className="admission-counselling-field">
                    What do you want to discuss?
                    <small> Optional</small>

                    <textarea
                      value={counsellingGoal}
                      onChange={(e) =>
                        setCounsellingGoal(e.target.value.slice(0, 500))
                      }
                      placeholder="Share career confusion, goal, ambition, learning challenge or any question."
                      maxLength={500}
                    />

                    <b>{counsellingGoal.length}/500 characters</b>
                  </label>

                  <div className="admission-counselling-fee-box">
                    <p>
                      <span>Selected Slot</span>
                      <strong>
                        {counsellingSelectedSlot
                          ? `${activeCounsellingDay?.dateText} • ${counsellingSelectedSlot.time}`
                          : "Not selected"}
                      </strong>
                    </p>

                    <p>
                      <span>Counselling Fee</span>
                      ₹{registrationFee.toFixed(2)}
                    </p>

                    <p>
                      <span>GST ({gstPercent}%)</span>
                      ₹{((registrationFee * gstPercent) / 100).toFixed(2)}
                    </p>

                    <p>
                      <span>Total Payable</span>
                      ₹{(registrationFee + (registrationFee * gstPercent) / 100).toFixed(2)}
                    </p>
                  </div>

                  <button
                    className="admission-counselling-pay-btn"
                    type="button"
                    disabled={counsellingPaymentStarted}
                    onClick={handleAdmissionCounsellingPayment}
                  >
                    {counsellingPaymentStarted
                      ? "Starting Payment..."
                      : `Pay ₹${(registrationFee + (registrationFee * gstPercent) / 100).toFixed(2)} & Confirm Counselling`}
                  </button>
                </div>
              </div>
            </div>
          </>
        )}


      {showCouponSuccessModal && couponData && (
        <div className="coupon-success-overlay">
          <div className="coupon-success-modal">
            <button
              type="button"
              className="coupon-success-close"
              onClick={() => setShowCouponSuccessModal(false)}
            >
              ×
            </button>

            <span>COUPON APPLIED SUCCESSFULLY</span>

            <h2>Congratulations!</h2>

            <p>
              You received a discount of{" "}
              <b>
                ₹{Number(couponData.student_discount_amount || 0).toLocaleString(
                  "en-IN"
                )}
              </b>{" "}
              using coupon <b>{couponData.coupon_code}</b>.
            </p>

            <div className="coupon-success-info">
              <div>
                <strong>One-Time Payment</strong>
                <p>
                  Discount is applied immediately. You pay the discounted Technology
                  Learning Fee now.
                </p>
              </div>

              <div>
                <strong>Installment Plan</strong>
                <p>
                  First installment remains same. Your discount is adjusted in the
                  final installments, especially the last month.
                </p>
              </div>
            </div>

            <button
              type="button"
              className="coupon-success-action"
              onClick={() => setShowCouponSuccessModal(false)}
            >
              Continue to Payment
            </button>
          </div>
        </div>
      )}

      {PaymentOptionShow && (
        <>
          <div className="payment-overlay"></div>

          <div className="payment-options-scroll-shell">
            <div className="coupon-box">
              {!couponApplied ? (
                <>
                  <h3>Have a referral coupon?</h3>
                  <p>
                    Apply coupon and get{" "}
                    <b>
                      ₹{Number(paymentConfig?.coupon_discount || 5000).toLocaleString(
                        "en-IN"
                      )}
                    </b>{" "}
                    discount on your programme admission fee.
                  </p>

                  <div className="coupon-input-row">
                    <input
                      type="text"
                      value={couponCode}
                      placeholder="ENTER COUPON CODE"
                      maxLength={20}
                      onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                    />

                    <button
                      type="button"
                      disabled={couponApplying}
                      onClick={handleApplyCoupon}
                    >
                      {couponApplying ? "Checking..." : "Apply"}
                    </button>
                  </div>
                </>
              ) : (
                <div className="coupon-applied-box">
                  <span>COUPON APPLIED</span>

                  <h3>
                    Congratulations! You saved ₹
                    {couponDiscountAmount.toLocaleString("en-IN")}
                  </h3>

                  <p>
                    Coupon <b>{couponCode}</b> is active. This discount applies only
                    to your programme admission fee.
                  </p>

                  <button
                    type="button"
                    onClick={() => {
                      setCouponApplied(false);
                      setCouponData(null);
                      setCouponCode("");
                    }}
                  >
                    Remove Coupon
                  </button>
                </div>
              )}
            </div>

            <div className="pricing-container program-fee-options">
              <div className="O-payment-card admission-single-payment-card">
                <span className="admission-fee-eyebrow">
                  COMPLETE PROGRAMME ADMISSION
                </span>

                <h2 className="O-payment-title">
                  Programme Admission Fee
                </h2>

                <p>
                  One straightforward admission payment, including
                  applicable GST.
                </p>

                <div className="plan-summary-box">
                  <div className="plan-summary-row">
                    <span>Standard Admission Fee</span>
                    <b>₹32,500</b>
                  </div>

                  {couponApplied && (
                    <div className="plan-summary-row">
                      <span>Referral Discount</span>
                      <b className="discount-text">−₹5,000</b>
                    </div>
                  )}

                  <div className="plan-summary-row">
                    <strong>Total Payable</strong>
                    <strong>
                      ₹{(couponApplied ? 27500 : 32500).toLocaleString("en-IN")}
                    </strong>
                  </div>
                </div>

                <p className="admission-fee-small-note">
                  Maximum one referral discount per student.
                  No additional programme installment payment.
                </p>

                <button
                  type="button"
                  className="O-pay-button"
                  disabled={PaymentOrderGenerated || !admissionSessionToken}
                  onClick={() =>
                    createOrderInitialOrder(
                      "New Admission",
                      couponApplied ? 27500 : 32500
                    )
                  }
                >
                  {PaymentOrderGenerated
                    ? "Preparing Payment..."
                    : "Pay Admission Fee"}
                </button>
              </div>
            </div>
          </div>
        </>
      )}


      {showInstallmentSchedule && (
        <div className="installment-popup-overlay">
          <div className="installment-popup-card">
            <button
              type="button"
              className="installment-popup-close"
              onClick={() => setShowInstallmentSchedule(false)}
            >
              Close
            </button>

            <h2>Installment Schedule</h2>

            <p className="installment-popup-subtitle">
              Your installment plan is divided across 7 months.
            </p>


            <div className="installment-popup-list">
              {installmentSchedule.map((item) => {
                let discountForThisInstallment = 0;

                if (couponApplied) {
                  if (item.installment_number === 7) {
                    discountForThisInstallment = Math.min(
                      item.amount_inr,
                      couponDiscountAmount
                    );
                  }

                  if (item.installment_number === 6 && couponDiscountAmount > 4100) {
                    discountForThisInstallment = couponDiscountAmount - 4100;
                  }
                }

                const finalBaseAmount = Math.max(
                  item.amount_inr - discountForThisInstallment,
                  0
                );
                const finalGstAmount = getGstAmount(finalBaseAmount);
                const finalTotalAmount = finalBaseAmount + finalGstAmount;

                return (
                  <div
                    className="installment-popup-row gst-row"
                    key={item.installment_number}
                  >
                    <span>{item.installment_number} Installment</span>

                    <small>Month {item.month_number}</small>

                    <div className="installment-amount-breakup">
                      {discountForThisInstallment > 0 ? (
                        <>
                          <b>
                            <del>₹{item.amount_inr.toLocaleString("en-IN")}</del>{" "}
                            ₹{finalBaseAmount.toLocaleString("en-IN")}
                          </b>

                          <em>
                            Discount ₹{discountForThisInstallment.toLocaleString("en-IN")}
                          </em>

                          <strong>
                            Total ₹{finalTotalAmount.toLocaleString("en-IN")}
                          </strong>
                        </>
                      ) : (
                        <>
                          <b>₹{item.amount_inr.toLocaleString("en-IN")}</b>
                          <em>
                            GST ₹{getGstAmount(item.amount_inr).toLocaleString("en-IN")}
                          </em>
                          <strong>
                            Total ₹{getTotalWithGst(item.amount_inr).toLocaleString("en-IN")}
                          </strong>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="installment-popup-total installment-grand-total">
              <span>Total Base Fee</span>

              <b>
                {couponApplied ? (
                  <>
                    <del>₹{installmentBaseTotal.toLocaleString("en-IN")}</del>{" "}
                    ₹{discountedInstallmentTotalFee.toLocaleString("en-IN")}
                  </>
                ) : (
                  <>₹{installmentBaseTotal.toLocaleString("en-IN")}</>
                )}
              </b>
            </div>

            {couponApplied && (
              <div className="installment-popup-total installment-grand-total">
                <span>Coupon Discount</span>
                <b className="discount-text">
                  -₹{couponDiscountAmount.toLocaleString("en-IN")}
                </b>
              </div>
            )}

            <div className="installment-popup-total installment-grand-total">
              <span>Total GST</span>

              <b>
                {couponApplied ? (
                  <>
                    <del>₹{installmentGstTotal.toLocaleString("en-IN")}</del>{" "}
                    ₹{discountedInstallmentTotalGst.toLocaleString("en-IN")}
                  </>
                ) : (
                  <>₹{installmentGstTotal.toLocaleString("en-IN")}</>
                )}
              </b>
            </div>

            <div className="installment-popup-total installment-grand-total final">
              <span>Total Payable With GST</span>

              <b className="final-discount-price">
                {couponApplied ? (
                  <>
                    <del>₹{installmentGrandTotal.toLocaleString("en-IN")}</del>{" "}
                    ₹{discountedInstallmentGrandTotal.toLocaleString("en-IN")}
                  </>
                ) : (
                  <>₹{installmentGrandTotal.toLocaleString("en-IN")}</>
                )}
              </b>
            </div>

            <button
              className="O-pay-button"
              onClick={() => {
                setShowInstallmentSchedule(false);
                prepareTrainingPayment("INSTALLMENT");
              }}
            >
              Pay First Installment
            </button>
          </div>
        </div>
      )}

      {showSuccessScreen && (
        <PaymentSuccessScreen customMessage={successMessage} />
      )}
    </div>
  );

};

export default TakeAdmission;
